import { render, staticRenderFns } from "./AuthLoginSocial.vue?vue&type=template&id=b1b0deca&scoped=true&lang=pug&"
import script from "./AuthLoginSocial.vue?vue&type=script&lang=js&"
export * from "./AuthLoginSocial.vue?vue&type=script&lang=js&"
import style0 from "./AuthLoginSocial.vue?vue&type=style&index=0&id=b1b0deca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b0deca",
  null
  
)

export default component.exports